@if (dataLoaded && detailsForm) {
    <div [formGroup]="detailsForm" class="tabcontent-container">
        <div class="row-item">
            <cerrix-field-wrapper [required]="true" label="Reporting organization" type="secondary">
                <cerrix-tree-select
                    placeholder="Select organizations"
                    [multiple]="false"
                    formControlName="organizationId"
                    [dataUiid]="'incident-details-reporting-organizations'"
                    [treeList]="reportedOrganizations"
                ></cerrix-tree-select>
            </cerrix-field-wrapper>
            <cerrix-field-wrapper label="Incident type" type="secondary">
                <cerrix-autocomplete
                    placeholder="Search..."
                    formControlName="incidentTypeIds"
                    [options]="incidentTypes"
                    [showDeleteWarning]="true"
                    [dataUiid]="'incident-details-incident-type'"
                    (ngModelChange)="onIncidentTypeChange.emit($event)"
                    [checkDeletable]="checkDeletable.bind(this)"
                ></cerrix-autocomplete>
            </cerrix-field-wrapper>
        </div>
        <div class="row-item">
            <cerrix-field-wrapper label="Caused by" type="secondary">
                <cerrix-tree-select
                    placeholder="Select organizations"
                    [multiple]="true"
                    formControlName="causedByOrganizationIds"
                    [dataUiid]="'incident-details-caused-by-organizations'"
                    [treeList]="causedByOrganizations"
                >
                    <organization-icon
                        left-icon
                        [matTooltip]="'Internal organization'"
                        [matTooltipClass]="'cerrix-tooltip'"
                    ></organization-icon>
                </cerrix-tree-select>

                <cerrix-autocomplete
                    placeholder="Search..."
                    formControlName="causedByThirdPartyIds"
                    [options]="causedByThirdparties"
                    [dataUiid]="'incident-details-caused-by-thirdparties'"
                >
                    <thirdparty-icon
                        left-icon
                        [matTooltip]="'Third party'"
                        [matTooltipClass]="'cerrix-tooltip'"
                    ></thirdparty-icon>
                </cerrix-autocomplete>
            </cerrix-field-wrapper>
            <cerrix-field-wrapper label="Affected" type="secondary">
                <cerrix-tree-select
                    placeholder="Select organizations"
                    [multiple]="true"
                    formControlName="affectedOrganizationIds"
                    [dataUiid]="'incident-details-affected-organizations'"
                    [treeList]="affectedOrganizations"
                >
                    <organization-icon
                        left-icon
                        [matTooltip]="'Internal organization'"
                        [matTooltipClass]="'cerrix-tooltip'"
                    ></organization-icon>
                </cerrix-tree-select>
                <cerrix-autocomplete
                    placeholder="Search..."
                    formControlName="affectedThirdPartyIds"
                    [options]="affectedThirdparties"
                    [dataUiid]="'incident-details-affected-thirdparties'"
                >
                    <button (click)="tooltip.show()">Show tooltip</button>
                    <thirdparty-icon
                        left-icon
                        #tooltip="matTooltip"
                        [matTooltip]="'Third party'"
                        [matTooltipClass]="'cerrix-tooltip'"
                    ></thirdparty-icon>
                </cerrix-autocomplete>
            </cerrix-field-wrapper>
        </div>
        <div class="row-item">
            <cerrix-field-wrapper label="Rootcause category" type="secondary">
                <cerrix-tree-select
                    placeholder="Select rootcause category"
                    [multiple]="true"
                    formControlName="rootCauseCategoryIds"
                    [treeList]="rootCauseCategories"
                    [dataUiid]="'incident-details-rootcause-category'"
                ></cerrix-tree-select>
            </cerrix-field-wrapper>
            <cerrix-field-wrapper label="Classification" type="secondary">
                <cerrix-select
                    placeholder="Select classification"
                    formControlName="classificationId"
                    [options]="classifications"
                    [dataUiid]="'incident-details-classification'"
                ></cerrix-select>
            </cerrix-field-wrapper>
        </div>
        <div class="row-item">
            <cerrix-field-wrapper label="Rootcause" type="secondary">
                <cerrix-textarea
                    [dataUiid]="'incident-details-rootcause'"
                    formControlName="rootCause"
                ></cerrix-textarea>
            </cerrix-field-wrapper>
        </div>
        <div class="row-item">
            <cerrix-field-wrapper label="Impact description" type="secondary">
                <cerrix-textarea
                    formControlName="impact"
                    [dataUiid]="'incident-details-impact'"
                ></cerrix-textarea>
            </cerrix-field-wrapper>
        </div>
        <div class="row-item">
            <cerrix-field-wrapper label="Business dimensions" type="secondary">
                <cerrix-tree-select
                    placeholder="Select business dimensions"
                    [multiple]="true"
                    formControlName="businessDimensionIds"
                    [treeList]="businessDimensions"
                    [dataUiid]="'incident-details-business-dimensions'"
                ></cerrix-tree-select>
            </cerrix-field-wrapper>
            <cerrix-field-wrapper label="Framework dimensions" type="secondary">
                <cerrix-tree-select
                    placeholder="Select framework dimensions"
                    [multiple]="true"
                    formControlName="frameworkDimensionIds"
                    [treeList]="frameworkDimensions"
                    [dataUiid]="'incident-details-framework-dimensions'"
                ></cerrix-tree-select>
            </cerrix-field-wrapper>
        </div>
        <div class="row-item">
            <cerrix-field-wrapper label="Internal identifier" type="secondary">
                <cerrix-input
                    formControlName="internalIdentifier"
                    [dataUiid]="'incident-details-internal-identifier'"
                ></cerrix-input>
            </cerrix-field-wrapper>
            <div></div>
        </div>
    </div>
} @else {
    <div class="fancy-loader submodule"></div>
}
